



































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import SupervisiJenazahService from "@/services/SupervisiJenazahService";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";
import { appModule } from "@/store/modules/app";

interface ChecklistItem {
  key: string;
  label: string;
}

interface ChecklistSection {
  code: string;
  title: string;
  items: ChecklistItem[];
}

/** Tanggal pembawa untuk isian jam-saja (nilai tersimpan tetap "HH:mm"). */
const JAM_CARRIER = toDateString(new Date()) || "2000-01-01";

@Component({ components: { VCDateTimePicker } })
export default class SupervisiJenazahFormDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: null }) editData!: any;

  saving = false;

  form: any = {};

  sectionI: ChecklistItem[] = [
    { key: "s1_jalur_keluar_masuk", label: "Jalur keluar masuk jenazah berbeda" },
  ];

  sectionII: ChecklistItem[] = [
    { key: "s2_sarana_cuci_tangan", label: "Tersedia sarana cuci tangan lengkap" },
    { key: "s2_apd_lengkap", label: "Tersedia APD lengkap" },
    { key: "s2_permukaan_tidak_berdebu", label: "Permukaan tidak berdebu" },
    { key: "s2_dinding_tidak_berjamur", label: "Dinding tidak berjamur" },
    { key: "s2_limbah_tertutup", label: "Tempat limbah tertutup" },
    { key: "s2_tidak_ada_lawa_lawa", label: "Tidak ada lawa-lawa" },
    { key: "s2_fasilitas_hand_hygiene", label: "Fasilitas kebersihan tangan: sabun, tisu dan handrub" },
    { key: "s2_kebersihan_kereta", label: "Kebersihan kereta jenazah" },
    { key: "s2_kebersihan_transit", label: "Kebersihan tempat transit jenazah" },
    { key: "s2_kebersihan_kain_penutup", label: "Kebersihan kain penutup jenazah" },
    { key: "s2_kebersihan_gorden", label: "Kebersihan gorden" },
    { key: "s2_air_limbah_lancar", label: "Air limbah bekas pencucian jenazah mengalir lancar" },
  ];

  sectionIII: ChecklistItem[] = [
    { key: "s3_apd_sesuai_jenis", label: "Penggunaan APD yang sesuai dengan jenis jenazah infeksius / non infeksius" },
    { key: "s3_komponen_sop_lokal", label: "Komponen SOP lokal RS" },
    { key: "s3_kantong_peti_jenazah", label: "Jenazah infeksius dimasukkan dalam kantong jenazah dan peti jenazah" },
    { key: "s3_pembuangan_limbah", label: "Petugas patuh dalam pembuangan limbah (infeksius, non infeksius dan B3)" },
    { key: "s3_pengelolaan_linen", label: "Petugas patuh dalam pengelolaan linen (infeksius dan non infeksius)" },
  ];

  sectionIV: ChecklistItem[] = [
    { key: "s4_kebersihan_tangan", label: "Melakukan kebersihan tangan" },
    { key: "s4_apd_sesuai_kebutuhan", label: "Menggunakan APD sesuai kebutuhan" },
    { key: "s4_buang_limbah_standar", label: "Membuang limbah sesuai standar" },
  ];

  get sections(): ChecklistSection[] {
    return [
      { code: "s1", title: "I. SUPERVISI ALUR", items: this.sectionI },
      { code: "s2", title: "II. SUPERVISI FASILITAS DAN KEBERSIHAN", items: this.sectionII },
      { code: "s3", title: "III. SUPERVISI PROSES PENATALAKSANAAN JENAZAH", items: this.sectionIII },
      { code: "s4", title: "IV. SUPERVISI KEPATUHAN PETUGAS", items: this.sectionIV },
    ];
  }

  get allItems(): ChecklistItem[] {
    return this.sections.reduce(
      (acc: ChecklistItem[], s: ChecklistSection) => acc.concat(s.items),
      []
    );
  }

  /**
   * Nilai item bersifat tri-state: true = Ya, false = Tidak, null = belum dinilai.
   * Mencentang kolom yang sudah aktif akan membatalkan penilaian.
   */
  toggleNilai(key: string, val: boolean) {
    this.$set(this.form, key, this.form[key] === val ? null : val);
  }

  created() {
    this.form = this.getEmptyForm();
  }

  get dialogVisible() {
    return this.value;
  }

  set dialogVisible(val: boolean) {
    this.$emit("input", val);
  }

  get isEdit() {
    return this.editData && this.editData.id;
  }

  get isFormValid() {
    return (
      this.form.nomor_formulir &&
      this.form.tanggal_supervisi &&
      this.form.waktu_mulai &&
      this.form.waktu_selesai &&
      this.form.supervisor_nama
    );
  }

  @Watch("value")
  onDialogOpen(val: boolean) {
    if (val) {
      if (this.editData && this.editData.id) {
        this.populateForm(this.editData);
      } else {
        this.form = this.getEmptyForm();
      }
    }
  }

  getEmptyForm() {
    const form: any = {
      nomor_formulir: "",
      tanggal_supervisi: "",
      waktu_mulai: "",
      waktu_selesai: "",
      supervisor_nama: "",
      supervisor_jabatan: "",
      temuan_utama: "",
      rencana_tindak_lanjut: "",
      supervisor_ttd_nama: "",
      supervisor_ttd_tanggal: "",
      kepala_unit_ttd_nama: "",
      kepala_unit_ttd_tanggal: "",
    };

    for (const item of this.allItems) {
      form[item.key] = null; // belum dinilai
      form[item.key + "_masalah"] = "";
      form[item.key + "_rekomendasi"] = "";
    }

    return form;
  }

  get tanggalSupervisiDate(): Date | null {
    return composeDate(this.form.tanggal_supervisi);
  }
  set tanggalSupervisiDate(val: Date | null) {
    this.$set(this.form, "tanggal_supervisi", toDateString(val) || "");
  }

  get waktuMulaiDate(): Date | null {
    if (!this.form.waktu_mulai) return null;
    return composeDate(JAM_CARRIER, String(this.form.waktu_mulai).slice(0, 5));
  }
  set waktuMulaiDate(val: Date | null) {
    this.$set(this.form, "waktu_mulai", toTimeString(val));
  }

  get waktuSelesaiDate(): Date | null {
    if (!this.form.waktu_selesai) return null;
    return composeDate(JAM_CARRIER, String(this.form.waktu_selesai).slice(0, 5));
  }
  set waktuSelesaiDate(val: Date | null) {
    this.$set(this.form, "waktu_selesai", toTimeString(val));
  }

  get supervisorTtdTanggalDate(): Date | null {
    return composeDate(this.form.supervisor_ttd_tanggal);
  }
  set supervisorTtdTanggalDate(val: Date | null) {
    this.$set(this.form, "supervisor_ttd_tanggal", toDateString(val) || "");
  }

  get kepalaUnitTtdTanggalDate(): Date | null {
    return composeDate(this.form.kepala_unit_ttd_tanggal);
  }
  set kepalaUnitTtdTanggalDate(val: Date | null) {
    this.$set(this.form, "kepala_unit_ttd_tanggal", toDateString(val) || "");
  }

  populateForm(data: any) {
    this.form = { ...this.getEmptyForm() };
    for (const key of Object.keys(this.form)) {
      if (data[key] !== undefined && data[key] !== null) {
        this.form[key] = data[key];
      }
    }
    if (this.form.tanggal_supervisi) {
      this.form.tanggal_supervisi = this.form.tanggal_supervisi.substring(0, 10);
    }
    if (this.form.waktu_mulai) {
      this.form.waktu_mulai = String(this.form.waktu_mulai).substring(0, 5);
    }
    if (this.form.waktu_selesai) {
      this.form.waktu_selesai = String(this.form.waktu_selesai).substring(0, 5);
    }
    if (this.form.supervisor_ttd_tanggal) {
      this.form.supervisor_ttd_tanggal = this.form.supervisor_ttd_tanggal.substring(0, 10);
    }
    if (this.form.kepala_unit_ttd_tanggal) {
      this.form.kepala_unit_ttd_tanggal = this.form.kepala_unit_ttd_tanggal.substring(0, 10);
    }
  }

  async save() {
    this.saving = true;
    try {
      if (this.isEdit) {
        await SupervisiJenazahService.update(this.editData.id, this.form);
        appModule.sendSuccessNotice("Supervisi berhasil diperbarui");
      } else {
        await SupervisiJenazahService.create(this.form);
        appModule.sendSuccessNotice("Supervisi berhasil ditambahkan");
      }
      this.$emit("saved");
      this.close();
    } finally {
      this.saving = false;
    }
  }

  close() {
    this.dialogVisible = false;
  }
}
